import React from 'react';
import Legend from './Legend';
/** Ordinal scales map from strings to an Output type. */

export default function Ordinal(props) {
  return /*#__PURE__*/React.createElement(Legend, props);
}